export const MCO_SITE_SECTION_ID = 'mco-passengers';
export const BUSINESS_SITE_SECTION_ID = 'business-site-section';
export const ORL_SITE_SECTION_ID = 'orl-site-section';
export const MCO_CARES_SITE_SECTION_ID = 'mco-cares';
export const OTHER_WEBSITES_SITE_SECTION_ID = 'other-websites';

export enum SiteSectionIds {
	MCO = MCO_SITE_SECTION_ID,
	ORL = ORL_SITE_SECTION_ID,
	BUSINESS = BUSINESS_SITE_SECTION_ID,
	MCOCARES = MCO_CARES_SITE_SECTION_ID,
	OTHER = OTHER_WEBSITES_SITE_SECTION_ID,
}
